// extracted by mini-css-extract-plugin
module.exports = {"header":"HeaderTag_header__i3but"};